export default __webpack_public_path__ + "static/3downloads-acd4244a9db834fd26f9781d0a42224a.png";